import '../../styles/ServiceProcess.css';

type ProcessSteps = {
    step?: number; 
    title: string;
    description: string;
};

type ServiceProcessProps = {
  sectionHeading: string;
  steps: ProcessSteps[];
};

const ServiceProcess: React.FC<ServiceProcessProps> = ({ sectionHeading, steps }) => {
  return (
    <section className="serviceProcess-section">
        <div className='serviceProcess-content'>
            <p className="sections-title">{sectionHeading}</p>
            <div className="serviceProcess-container">
                {steps.map((step, index) => (
                <div 
                    key={index} 
                    className={`serviceProcess-card ${step.step ? 'with-step' : 'without-step'}`}
                >
                    {step.step && (
                        <div className='serviceProcess-StepNumber'>Step {step.step}</div>
                    )}
                    <div className='serviceProcess-card-content'>
                        <p className='serviceProcess-title'>{step.title}</p>
                        <p className="serviceProcess-desc">{step.description}</p>
                    </div>
                </div>
                ))}
            </div>
        </div>
    </section>
  );
};

export default ServiceProcess;